module.exports = __webpack_public_path__ + "static/media/26.9d391273.jpg";